/* =====================================================================
   Option viewer — 1776 Atelier
   Tap a configurator swatch to study the choice full-screen: the strap,
   engraving or dial at the size its photograph honestly supports, with
   its name, its price, and the house pill to select it right there.
   Speaks the gallery lightbox's glass language; shares its CSS chrome.
   Self-contained. No dependencies. No-op on pages without a configurator.
   ===================================================================== */
(function () {
  var fieldsets = Array.prototype.slice.call(document.querySelectorAll('fieldset.grp'));
  if (!fieldsets.length) return;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var PEEK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/>' +
    '</svg>';

  /* ---- collect the options, grouped as the form groups them ---- */
  var groups = [];
  fieldsets.forEach(function (fs) {
    var items = [];
    var gi = groups.length;
    Array.prototype.slice.call(fs.querySelectorAll('label.opt')).forEach(function (lab) {
      var thumb = lab.querySelector('.opt-thumb');
      var im = thumb && thumb.querySelector('img');
      var input = lab.querySelector('input');
      if (!thumb || !im || !input) return;
      var nameEl = lab.querySelector('.opt-name');
      var tagEl = lab.querySelector('.opt-tag');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var idx = items.length;
      items.push({
        src: im.getAttribute('src'),
        name: name,
        tag: tagEl ? tagEl.textContent.trim() : '',
        input: input
      });

      /* the swatch becomes a doorway: keyboard-reachable, announced */
      thumb.removeAttribute('aria-hidden');
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('aria-label', 'View ' + (name || 'option') + ' full screen');

      /* the quiet magnifier cue, same mark as the gallery's */
      var peek = document.createElement('span');
      peek.className = 'opt-peek';
      peek.setAttribute('aria-hidden', 'true');
      peek.innerHTML = PEEK_SVG;
      thumb.appendChild(peek);

      function openThis(e) {
        /* the thumb lives inside the label — stop the tap from also
           toggling the radio, so viewing is never mistaken for choosing */
        e.preventDefault();
        e.stopPropagation();
        openAt(gi, idx);
      }
      thumb.addEventListener('click', openThis);
      thumb.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') openThis(e);
      });
    });
    if (items.length) groups.push(items);
  });
  if (!groups.length) return;

  /* ---- build the overlay once, in the lightbox's own chrome ---- */
  var lb = document.createElement('div');
  lb.className = 'lb olb';
  lb.setAttribute('role', 'dialog');
  lb.setAttribute('aria-modal', 'true');
  lb.setAttribute('aria-label', 'Option viewer');
  lb.innerHTML =
    '<button class="lb-btn lb-close" type="button" aria-label="Close viewer">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
    '</button>' +
    '<button class="lb-btn lb-arrow lb-arrow--prev" type="button" aria-label="Previous option">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>' +
    '</button>' +
    '<button class="lb-btn lb-arrow lb-arrow--next" type="button" aria-label="Next option">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
    '</button>' +
    '<div class="lb-stage"><img class="lb-img" alt="" draggable="false" /></div>' +
    '<div class="olb-foot">' +
      '<p class="olb-name"></p>' +
      '<p class="olb-tag"></p>' +
      '<button class="olb-select" type="button"><span></span></button>' +
    '</div>' +
    '<div class="lb-count" aria-hidden="true"></div>';
  document.body.appendChild(lb);

  var stage = lb.querySelector('.lb-stage');
  var img = lb.querySelector('.lb-img');
  var nameEl = lb.querySelector('.olb-name');
  var tagEl = lb.querySelector('.olb-tag');
  var selBtn = lb.querySelector('.olb-select');
  var selLabel = selBtn.querySelector('span');
  var count = lb.querySelector('.lb-count');
  var closeBtn = lb.querySelector('.lb-close');
  var prevBtn = lb.querySelector('.lb-arrow--prev');
  var nextBtn = lb.querySelector('.lb-arrow--next');

  var g = 0, i = 0, open = false;

  /* the photograph fills the stage, but only as far as its pixels honestly
     support — hi-res art scales up to the room, a 150px swatch stops at a
     dignified 2.6x card, never a blur blown to 84vh */
  function sizeImg() {
    if (!open || !img.naturalWidth) return;
    var r = stage.getBoundingClientRect();
    /* a degenerate rect (mid-transition, zero-size viewport) sizes nothing —
       wait a frame and measure again */
    if (r.width < 40 || r.height < 40) { requestAnimationFrame(sizeImg); return; }
    var s = Math.min(2.6, r.width / img.naturalWidth, r.height / img.naturalHeight);
    img.style.maxWidth = 'none';
    img.style.maxHeight = 'none';
    img.style.width = Math.round(img.naturalWidth * s) + 'px';
    img.style.height = 'auto';
  }
  img.addEventListener('load', sizeImg);
  window.addEventListener('resize', function () { if (open) sizeImg(); });

  function refreshSelect() {
    var it = groups[g][i];
    var checked = it.input.checked;
    selBtn.classList.toggle('is-current', checked);
    if (it.input.type === 'checkbox') selLabel.textContent = checked ? 'Remove' : 'Select';
    else selLabel.textContent = checked ? 'Selected' : 'Select';
  }

  function show(gi, ii) {
    g = gi;
    var N = groups[g].length;
    i = (ii % N + N) % N;
    var it = groups[g][i];
    img.style.maxWidth = '';
    img.style.maxHeight = '';
    img.style.width = '';
    img.style.height = '';
    img.src = it.src;
    img.alt = it.name;
    if (img.complete) sizeImg();
    nameEl.textContent = it.name;
    tagEl.textContent = it.tag;
    tagEl.style.display = it.tag ? '' : 'none';
    count.textContent = pad(i + 1) + ' / ' + pad(N);
    var one = N < 2;
    prevBtn.style.display = one ? 'none' : '';
    nextBtn.style.display = one ? 'none' : '';
    count.style.display = one ? 'none' : '';
    refreshSelect();
  }

  function openAt(gi, ii) {
    document.body.classList.add('lb-lock');
    lb.classList.add('is-open');
    open = true;
    show(gi, ii);
    if (closeBtn.focus) closeBtn.focus({ preventScroll: true });
  }
  function closeLb() {
    if (!open) return;
    open = false;
    lb.classList.remove('is-open');
    document.body.classList.remove('lb-lock');
  }

  /* ---- choosing from the viewer drives the form itself ---- */
  selBtn.addEventListener('click', function () {
    var it = groups[g][i];
    if (it.input.type === 'checkbox') it.input.checked = !it.input.checked;
    else it.input.checked = true;
    it.input.dispatchEvent(new Event('change', { bubbles: true }));
    refreshSelect();
    closeLb();
  });

  /* ---- controls, in the gallery's grammar ---- */
  closeBtn.addEventListener('click', closeLb);
  prevBtn.addEventListener('click', function () { show(g, i - 1); });
  nextBtn.addEventListener('click', function () { show(g, i + 1); });
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target === stage) closeLb();
  });
  window.addEventListener('keydown', function (e) {
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopImmediatePropagation(); closeLb(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); e.stopImmediatePropagation(); show(g, i + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); e.stopImmediatePropagation(); show(g, i - 1); }
  }, true);
})();
